import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/users.js';
import q from '../query.js';
export const usersEntity = 'users';
const userByIdKey = (id) => `users-${id}`;
export const useUserById = (id) => q.query(userByIdKey(id ?? ''), () => api.getById(id), keys.read.item(usersEntity, id ?? ''), { enabled: !!id });
const usersKey = 'users';
export const useUsers = () => q.query(usersKey, api.getAll, keys.read.collection(usersEntity));
//# sourceMappingURL=index.js.map